import { Container } from '@mui/material';
import Timetable from '../timetable/Timetable';

export default function Widget(): React.ReactElement {
    return (
        <Container maxWidth="md">
            <Timetable />
        </Container>
    );
}
